export default "__VITE_PUBLIC_ASSET__4725ad80__"